import { styled } from '@mui/material/styles';
import { orderFactLines, OrderFactSource } from './orderFacts';
import { vendorLinkColor } from './rowLink';

const FactLabel = styled('span')({
  fontWeight: 700,
  textTransform: 'capitalize',
});

export const CheckTitle = styled('span')(({ theme }) => ({
  color: vendorLinkColor(theme),
  fontSize: '14px',
  fontWeight: 700,
}));

const OrderFactLines = ({ source }: { source: OrderFactSource }) => {
  const lines = orderFactLines(source);
  if (!lines.length) return null;

  return (
    <>
      {lines.map(([label, value]) => (
        <small key={label}>
          <FactLabel>{label}:</FactLabel> {value}
        </small>
      ))}
    </>
  );
};

export default OrderFactLines;
